var EQ = {
  get_val: function get_val(name, string) {
    name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
    var result = (new RegExp("[\\?&]" + name + "=([^&#]*)")).exec(string);
    return (result === null) ? "" : result[1];
  },

  validate_required_fields: function () {
    var fields = $(".eq-email-wrapper").find("input:not(:button),select").add($(".eq-additional-params-wrapper").find("input:not(:button),select"));
    $(fields).css("background", "#fff");
    var ary = []
    $.map(fields, function (field, index) {
      // always set email as required
      if ($(field).attr("id") == "Email" || $(field).attr("id") == "cartEmail" || $(field).attr("id") == "productEmail") $(field).prop('required', true);

      if ($(field).val() === '' && $(field)[0].hasAttribute("required")) {
        ary.push(field)
        $(field).css("background", "rgba(255, 158, 158, 0.3)");
      }
    })
    if (ary.length > 0) return false;
    return true;
  },
  create_quote: function (url, params, el, shop) {
    $.ajax({
      type: "POST",
      dataType: "json",
      url: url,
      data: params,
      success: function (data) {
        if (data.ok == true) {
          el.html(window.EQS.success_message);
        } else {
          EQ.render_errors(data.errors, el)
        }
        return data;
      }
    });
  },

  create_quote_with_product_and_variant: function (url, params, el) {
    $.ajax({
      type: "POST",
      dataType: "json",
      url: url,
      data: params,
      success: function (data) {
        if (data.ok == true) {
          el.html(window.EQS.success_message);
        } else {
          EQ.render_errors(data.errors, el)
        }
        return data;
      }
    });
  },

  get_variant_id: function () {
    var url_params = new URLSearchParams(window.location.search);
    if (url_params.get("variant") == null) {
      return $("input#qteedy-variant-id").val()
    } else {
      return url_params.get("variant");
    }
  },

  serialize_params: function (element) {
    var arr = $(element).find(':input');
    if (typeof arr == 'object' && arr.length > 0) {
      var data = $(arr).serializeArray();
      var customer_params = data.reduce(function (acc, val) {
        acc[val.name.toLowerCase()] = val.value;
        return acc;
      }, {});
      return { customer: customer_params };
    }
  },

  get_current_cart: function () {
    return $.ajax({ type: "GET", url: "/cart.js", dataType: "text", contentType: "text/javascript; charset=utf-8" })
  },

  render_errors: function (errors_array, element) {
    EQ.clear_errors(element);
    $.map(errors_array, function (error, i) {
      $(element).append(error);
    })
  },

  clear_errors: function (element) {
    $(element).html("");
  },

  fetch_success_message: function (shop, url) {
    window.EQS = window.EQS || {};
    if (EQS.success_message != undefined) return EQS.success_message;
    $.get(url + "/message?domain=" + shop, function (data) {
      window.EQS.success_message = data;
      return data;
    });
  },

  fetch_validation_error_message: function (shop, url) {
    window.EQS = window.EQS || {};
    if (EQS.validtion_message != undefined) return EQS.validtion_message;
    $.get(url + "/validation_message?domain=" + shop, function (data) {
      window.EQS.validtion_message = data;
      return data;
    });
  },

  fetch_general_error_message: function (shop, url) {
    window.EQS = window.EQS || {};
    if (EQS.general_error_message != undefined) return EQS.general_error_message;
    $.get(url + "/general_error_message?domain=" + shop, function (data) {
      window.EQS.general_error_message = data;
      return data;
    });
  },

  get_shipping_rate: function () {
    if ($("#qteedy-shipping-rate").length > 0) {
      // matches 20, 20.12, 23.00, 1234.22
      return $("#qteedy-shipping-rate").val().match(/(\d+(,\d+\.\d{1,2}|\.\d{1,2})|\d{1,2})/)[0];
    }
    return null;
  },

  get_shipping_name: function () {
    if ($("#qteedy-shipping-rate").length > 0) {
      return $("#qteedy-shipping-rate").find(":selected").data("shipping-name");
    }
    return null;
  },

  // DEPRECATED
  get_customer_company: function () {
    var field = $(".eq-email-wrapper").find("input#Company");
    if (field.length > 0) {
      return $(field).val();
    }
    return false;
  },
  // DEPRECATED
  is_company_field_present: function () {
    var field = $(".eq-email-wrapper").find("input#Company");
    if (field.length > 0) {
      return true;
    }
    return false;
  },

  validateEmail: function (email) {
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  },
  create_quote_from_cart: function (e) {
    e.preventDefault();
    var btn = $("a#create-quote");
    var label = btn.html();
    var shop = EQ.get_val('shop', "https://app.easyquote.pw/easyquote.js?url=https://app.easyquote.pw&shop=sphero-production.myshopify.com");
    var url = EQ.get_val('url', "https://app.easyquote.pw/easyquote.js?url=https://app.easyquote.pw&shop=sphero-production.myshopify.com");
    var customer_email = $(".eq-email-wrapper").find("input#Email").val() || $(".eq-email-wrapper").find("input#cartEmail").val();
    var el = $("p#easyquote-status");

    EQ.clear_errors(el);
    btn.attr("disabled", true).html("Creating...");

    $.when(EQ.get_current_cart())
      .done(function (data) {
        var cart = JSON.parse(data);
        var shipping_rate = EQ.get_shipping_rate();
        var shipping_name = EQ.get_shipping_name();

        if (EQ.validate_required_fields() == false) {
          el.html(window.EQS.validtion_message);
          return false;
        }

        if (cart.items.length > 0 && (customer_email != undefined && customer_email.length > 1) && EQ.validateEmail(customer_email)) {
          var params = EQ.serialize_params($(".eq-email-wrapper"));
          var additional_params = EQ.serialize_params($(".eq-additional-params-wrapper"));
          params.customer.email = customer_email
          params.email = customer_email
          var prms = Object.assign(params, { cart: cart, shop: shop, shipping_rate: shipping_rate, shipping_name: shipping_name, additional_params: additional_params })
          EQ.create_quote(url + '/quotes', prms, el, shop);
        } else {
          el.html(EQS.general_error_message);
          return false;
        }
      }).fail(function (e) {
        el.html(e);
        return false;
      }).always(function (e) {
        btn.attr("disabled", false).html(label);
      });
  },
  create_quote_from_product: function (e) {
    e.preventDefault();
    var btn = $("a#create-quote");
    var label = btn.html();
    var shop = EQ.get_val('shop',"https://app.easyquote.pw/easyquote.js?url=https://app.easyquote.pw&shop=sphero-production.myshopify.com");
    var url = EQ.get_val('url', "https://app.easyquote.pw/easyquote.js?url=https://app.easyquote.pw&shop=sphero-production.myshopify.com");
    var customer_email = $(".eq-email-wrapper").find("input#Email").val() || $(".eq-email-wrapper").find("input#productEmail").val();
    var quantity = $('input[id*=Quantity]').val() || 1
    var product_id = $("input#qteedy-product-id").val()
    var variant_id = EQ.get_variant_id();
    var shipping_rate = EQ.get_shipping_rate();
    var shipping_name = EQ.get_shipping_name();
    var el = $("p#easyquote-status");

    EQ.clear_errors(el);
    btn.attr("disabled", true).html("Creating...");
    if (product_id.length == 0 || variant_id.length == 0 || !EQ.validateEmail(customer_email)) {
      el.html(EQS.general_error_message);
      return false;
    } else if (EQ.validate_required_fields() == false) {
      el.html(window.EQS.validtion_message);
      return false;
    } else {
      var params = EQ.serialize_params($(".eq-email-wrapper"));
      var additional_params = EQ.serialize_params($(".eq-additional-params-wrapper"));
      params.customer.email = customer_email
      var prms = Object.assign(params, {
        shipping_name: shipping_name,
        shipping_rate: shipping_rate,
        quantity: quantity,
        product_id: product_id,
        variant_id: variant_id,
        shop: shop,
        additional_params: additional_params
      })
      $.when(EQ.create_quote_with_product_and_variant(url + '/quotes_from_product', params, el))
        .done(function (data) {
          return;
        })
        .fail(function (e) {
          el.html(e);
          return false;
        })
        .always(function (e) {
          btn.attr("disabled", false).html(label);
        });
    }
    return;
  },
}

$(document).ready(function () {
  var shop = EQ.get_val('shop',"https://app.easyquote.pw/easyquote.js?url=https://app.easyquote.pw&shop=sphero-production.myshopify.com");
  var url = EQ.get_val('url', "https://app.easyquote.pw/easyquote.js?url=https://app.easyquote.pw&shop=sphero-production.myshopify.com");
  setTimeout(EQ.fetch_success_message(shop, url), 5000);
  setTimeout(EQ.fetch_validation_error_message(shop, url), 5000);
  setTimeout(EQ.fetch_general_error_message(shop, url), 5000);

  $('html body').on("click", "a#create-quote", function (e) {
    EQ.create_quote_from_cart(e);
  });

  $('html body').on("click", "a#create_quote_from_product", function (e) {
    EQ.create_quote_from_product(e);
  });
});
